import { toast } from 'react-hot-toast';

// Regular expression for basic email format validation
const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

// List of common disposable email domains
const DISPOSABLE_DOMAINS = [
  'tempmail.com',
  'throwawaymail.com',
  'mailinator.com',
  'guerrillamail.com',
  'sharklasers.com',
  'temp-mail.org',
  // Add more as needed
];

// List of valid email providers
const VALID_PROVIDERS = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'yahoo.com',
  'icloud.com',
  'proton.me',
  'protonmail.com',
  'aol.com',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'globo.com',
  // Add more as needed
];

export const validateEmail = (email: string): { isValid: boolean; message?: string } => {
  // Check basic email format
  if (!EMAIL_REGEX.test(email)) {
    return {
      isValid: false,
      message: 'Por favor, insira um email válido'
    };
  }

  // Get domain from email
  const domain = email.split('@')[1].toLowerCase();

  // Check if domain is in disposable list
  if (DISPOSABLE_DOMAINS.includes(domain)) {
    return {
      isValid: false,
      message: 'Emails temporários não são permitidos'
    };
  }

  // Check if domain is in valid providers list
  if (!VALID_PROVIDERS.includes(domain)) {
    return {
      isValid: false,
      message: 'Por favor, use um provedor de email conhecido'
    };
  }

  return { isValid: true };
};

export const validatePassword = (password: string): { isValid: boolean; message?: string } => {
  if (password.length < 8) {
    return {
      isValid: false,
      message: 'A senha deve ter pelo menos 8 caracteres'
    };
  }

  if (!/[A-Z]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos uma letra maiúscula'
    };
  }

  if (!/[a-z]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos uma letra minúscula'
    };
  }

  if (!/[0-9]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos um número'
    };
  }

  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos um caractere especial'
    };
  }

  return { isValid: true };
};